import React, { useEffect } from 'react';
import './App.css';
import Layout from './components/layout/Layout';
import Home from './screens/Home';
import Experience from './screens/Experience';
import Education from './screens/Education';
import Skills from './screens/Skills';
import Contact from './screens/Contact';
import Services from './screens/Services';
import CV from './screens/CV';
import {Routes, Route, useLocation} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/SEO';

function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [location.pathname]);

  return (
    <HelmetProvider>
      <Layout>
        <SEO />
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/experience" element={<Experience/>}/>
          <Route path="/education" element={<Education/>}/>
          <Route path="/skills" element={<Skills/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/services" element={<Services/>}/>
          <Route path="/cv" element={<CV/>}/>
          
          {/* Arabic routes */}
          <Route path="/ar" element={<Home/>}/>
          <Route path="/ar/experience" element={<Experience/>}/>
          <Route path="/ar/education" element={<Education/>}/>
          <Route path="/ar/skills" element={<Skills/>}/>
          <Route path="/ar/contact" element={<Contact/>}/>
          <Route path="/ar/services" element={<Services/>}/>
          <Route path="/ar/cv" element={<CV/>}/>
        </Routes>
      </Layout>
    </HelmetProvider>
  );
}

export default App;
